import C from 'actionTypes'

const defaultState = {
  documents: []
}

const documents = (state = defaultState, action) => {
  const { data } = action

  switch (action.type) {
    case C.SET_DOCUMENTS:
      return {
        ...state,
        documents: data,
      }
    case C.ADD_DOCUMENT:
      return {
        ...state,
        documents: state.documents.concat(data)
      }

    default:
      return state
  }
}

export default documents



// WEBPACK FOOTER //
// ./src/reducers/client/documents.js